// Copyright (c) Docugami, Inc. All rights reserved.

import { useEffect, useRef } from "react";
import { IEvent } from "utils/Event";

export function useEventListener<T>(event?: IEvent<T>, callback?: (value: T) => void, token?: any) {
    const callbackRef = useRef(callback);
    const eventRef = useRef(event);

    useEffect(() => {
        callbackRef.current = callback;
    }, [callback]);

    useEffect(() => {
        if (!eventRef.current) {
            return;
        }

        function onCallback(value: T) {
                callbackRef.current?.(value);
        }

        const unregister = eventRef.current.addListener(onCallback);
        return () => unregister();
    }, [token]);
}
